export default __webpack_public_path__ + "static/product-preview-14fded1fe7fd5699bd8b744a1d704940.png";